<div>
  <div style="width: 350px;"></div>

  <div class="side-bar-fixed">
    @if (showSideBarFixed()) {
      <div>
        <mat-nav-list class="side-bar-fixed-item">
          <br>
            <span style="padding: 10px; font-weight: 700;">Selecciona servicio</span>
            <button class="button-selected-app" [matMenuTriggerFor]="selectedApp" [disabled]="disableOfflineButton">
              <div fxFlex="100" class="menu-selected-opcion-app">
                <div fxFlex="90">
                  @if (appActive != null) {
                    <span class="color-sidebar-item" [style.color]="changeColorApp(idAppActive)">{{appActive}}</span>
                  }
                </div>
                <div fxFlex="10">
                  <mat-icon role="img" class="mat-icon notranslate material-icons">arrow_drop_down</mat-icon>
                </div>
              </div>
            </button>
            <mat-menu #selectedApp="matMenu">
              @for (item of profils; track item) {
                <div class="container-menu-main">
                  @if (appActive != null) {
                    <span class="color-sidebar-item" [style.color]="changeColorApp(item.idApp)" (click)="onSelectionOption(item.idApp)">{{item.appName}}</span>
                  }
                </div>
              }
            </mat-menu>
            <a class="first-level" mat-list-item (click)="redirectionPage()">
              <mat-icon class="icon-menu-item-sidebar">dashboard</mat-icon>
              {{ 'menu.home' | translate }}
            </a>
            @if (showAirItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('/protocols')">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}protocols.svg">
                {{ 'menu.manage-protocols' | translate }}
              </a>
            }
            @if (showAirItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('/executions')">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}executions.svg">
                {{ 'menu.service-executions' | translate }}
              </a>
            }
            @if (showQualificatesItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('/protocols')">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}protocols.svg">
                {{ 'menu.manage-protocols' | translate }}
              </a>
            }
            @if (showQualificatesItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('/executions')">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}executions.svg">
                {{ 'menu.service-executions' | translate }}
              </a>
            }
            <!-- Thermal-->
            @if (showThermalItem()) {
              <mat-expansion-panel class="exp-panel">
                <mat-expansion-panel-header>
                  <a class="first-level" fxFlex [routerLink]="checkRouterDisabledOffline('/protocols')">
                    <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}protocols.svg">
                    <div class="textAlign">
                      <span>{{ 'menu.manage-protocols' | translate }}</span>
                    </div>
                  </a>
                </mat-expansion-panel-header>
                @for (item of phases; track item; let index = $index) {
                  <div>
                    @if (item.enabled) {
                      <a mat-list-item class="first-level-submenu-item" (click)="goToProtocol(item)"
                      >{{ 'phase.'+ item.translation | translate }}</a>
                    }
                  </div>
                }
              </mat-expansion-panel>
            }
            @if (showThermalItem()) {
              <mat-expansion-panel class="exp-panel">
                <mat-expansion-panel-header>
                  <a class="first-level" fxFlex [routerLink]="checkRouterDisabledOffline('/executions')">
                    <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}executions.svg">
                    <div class="textAlign">
                      <span> {{ 'menu.service-executions' | translate }}</span>
                    </div>
                  </a>
                </mat-expansion-panel-header>
                @for (item of phases; track item; let index = $index) {
                  <div>
                    @if (item.enabled) {
                      <a mat-list-item class="first-level-submenu-item" (click)="goToExecutions(item);"
                        >{{ 'phase.'+
                      item.translation | translate }}</a>
                    }
                  </div>
                }
              </mat-expansion-panel>
            }
            @if (showCalibratesItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('/calibrations')"
                [class.disabled]="disableOfflineButton ? null: true">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}calibrates.svg">
                {{ 'menu.calibrate-equipments' | translate }}
              </a>
            }
            @if (showCharacterizationItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('/isothermalCharacterizations')"
                [class.disabled]="disableOfflineButton ? null: true">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}isothermalCharacterization.svg">
                {{ 'menu.isothermal-characterization' | translate }}
              </a>
            }
            @if (showBalanceMainItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('balances')"
                [class.disabled]="disableOfflineButton ? null: true">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}balances.svg">
                {{ 'menu.balances' | translate }}
              </a>
            }
            @if (showParticlesMainItem()) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('particles')"
                [class.disabled]="disableOfflineButton ? null: true">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}particlesCalibration.svg">
                {{ 'menu.particles-calibration' | translate }}
              </a>
            }
            <a class="first-level" mat-list-item [routerLink]="'/signature/box'"
              (click)="sidenav.close()" [class.disabled]="disableOfflineButton ? null: true">
              <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}internalEquipments.svg">
              {{ 'menu.inbox-sign' | translate }}
            </a>
            <mat-expansion-panel class="exp-panel">
              <mat-expansion-panel-header>
                <a class="first-level" fxFlex [routerLink]="checkRouterDisabledOffline('/internalEquipments')"
                  [class.disabled]="disableOfflineButton ? null: true">
                  <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}internalEquipments.svg">
                  <div class="textAlign">
                    <span style="margin: auto;">{{ 'menu.my-equipments' | translate }}</span>
                  </div>
                </a>
              </mat-expansion-panel-header>
              @if (showCalibrationPlan()) {
                <a class="second-level" mat-list-item
                  [routerLink]="checkRouterDisabledOffline('/admin/calibrationPlan')"
                  [class.disabled]="disableOfflineButton ? null: true">
                  {{ 'menu.manage-calibratioPlan' | translate }}
                </a>
              }
              <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <!-- This is the tree node template for leaf nodes -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="5">
                  <!-- use a disabled button to provide padding for tree leaf -->
                  <button mat-icon-button disabled></button>
                  <a style="cursor: pointer;" (click)="goToInternalEquipment(node);">
                    {{ node.name | translate }}
                  </a>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding
                  matTreeNodePaddingIndent="10">
                  <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                    <mat-icon class="mat-icon-rtl-mirror">
                      {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                    </mat-icon>
                  </button>
                  <a style="cursor: pointer;" (click)="goToInternalEquipment(node);">
                    {{ node.name | translate }}
                  </a>
                </mat-tree-node>
              </mat-tree>
            </mat-expansion-panel>
            @if ((showCalibratesItem() || showBalanceItem()) && user.showExternalEquipments) {
              <a class="first-level" mat-list-item
                [routerLink]="checkRouterDisabledOffline('/externalEquipments')"
                [class.disabled]="disableOfflineButton ? null: true">
                <img class="icon-menu-item-sidebar" src="{{ getThemeIconPath() }}externalEquipments.svg">
                {{ 'menu.manage-external-equipments' | translate }}
              </a>
            }
            @if ((user.admin || showManageClients()) && !this.disableOfflineButton) {
              <mat-divider></mat-divider>
            }
            @if ((user.admin || showManageClients()) && !this.disableOfflineButton) {
              <mat-expansion-panel class="exp-panel">
                <mat-expansion-panel-header>
                  <a class="first-level" [class.disabled]="disableOfflineButton ? null: true">
                    <mat-icon class="icon-menu-item-sidebar">settings</mat-icon>
                    <div class="textAlign">
                      <span> {{ 'menu.manage-setting' | translate }}</span>
                    </div>
                  </a>
                </mat-expansion-panel-header>
                @if (showManageClients()) {
                  <a class="second-level" mat-list-item [routerLink]="checkRouterDisabledOffline('/clients')"
                    [class.disabled]="disableOfflineButton ? null: true">
                    <div class="textAlign">
                      {{ 'menu.manage-clients' | translate }}
                    </div>
                  </a>
                }
                @if (user.admin) {
                  <a class="second-level" mat-list-item
                    [routerLink]="checkRouterDisabledOffline('/admin/manageUsers')"
                    [class.disabled]="disableOfflineButton ? null: true">
                    <div class="textAlign">
                      {{ 'menu.manage-users' | translate }}
                    </div>
                  </a>
                }
                @if (user.admin) {
                  <a class="second-level" mat-list-item
                    [routerLink]="checkRouterDisabledOffline('/admin/manageGroups')"
                    [class.disabled]="disableOfflineButton ? null: true">
                    <div class="textAlign">
                      {{ 'menu.manage-groups' | translate }}
                    </div>
                  </a>
                }
                @if (user.admin) {
                  <a class="second-level" mat-list-item [routerLink]="checkRouterDisabledOffline('/admin/procedure')"
                    [class.disabled]="disableOfflineButton ? null: true">
                    <div class="textAlign">
                      {{ 'menu.manage-procedures' | translate }}
                    </div>
                  </a>
                }
              </mat-expansion-panel>
            }
            @if ((user.admin || showManageClients()) && !this.disableOfflineButton) {
              <mat-expansion-panel class="exp-panel">
                <mat-expansion-panel-header>
                  <a class="first-level" [class.disabled]="disableOfflineButton ? null: true">
                    <mat-icon class="icon-menu-item-sidebar">notifications_active</mat-icon>
                    <div class="textAlign">
                      <span style="margin: auto;"> {{ 'menu.item.manage-notifications' | translate}}</span>
                    </div>
                  </a>
                </mat-expansion-panel-header>
                @if (user.admin || showManageClients()) {
                  <a class="second-level" mat-list-item
                    [routerLink]="checkRouterDisabledOffline('/admin/notifications')"
                    [class.disabled]="disableOfflineButton ? null: true">
                    {{ 'menu.manage-notifications' | translate }}
                  </a>
                }
                @if (user.admin && !user.manager) {
                  <a class="second-level" mat-list-item
                    [routerLink]="checkRouterDisabledOffline('/admin/sendNotifications')"
                    [class.disabled]="disableOfflineButton ? null: true">
                    {{ 'menu.send-notifications' | translate }}
                  </a>
                }
              </mat-expansion-panel>
            }
            @if ((user.admin && !user.manager) && !this.disableOfflineButton) {
              <a class="first-level" mat-list-item [routerLink]="checkRouterDisabledOffline('/admin/manageAppPlan')"
                [class.disabled]="disableOfflineButton ? null: true">
                <mat-icon class="icon-menu-item-sidebar">work_outline</mat-icon>
                {{ 'menu.manage-appPlan' | translate }}
              </a>
            }
            @if (showChangeLangIcon() && !this.disableOfflineButton) {
              <a class="first-level" mat-list-item [matMenuTriggerFor]="lang">
                <mat-icon class="icon-menu-item-sidebar">language</mat-icon>
                <mat-icon svgIcon="{{activeFlag}}"></mat-icon>
                <span style="margin-left: 10px;">{{activeNameFlag}}</span>
                <mat-menu #lang="matMenu">
                  @for (item of langs; track item) {
                    <div>
                      @if ((translationService.lang$ | async) != item.lang) {
                        <button mat-menu-item
                          (click)="changeLang(item)">
                          <mat-icon svgIcon="{{item.flag}}"></mat-icon>
                          <span>{{item.fullLang}}</span>
                        </button>
                      }
                    </div>
                  }
                </mat-menu>
              </a>
            }
          </mat-nav-list>
        </div>
      }
    </div>
  </div>